<template>
  <Layout>
    <Breadcrumb :items="items" :title="title" />

    <b-row>
      <b-col sm="12">
        <!-- Profile -->
        <div class="card bg-primary">
          <div class="card-body profile-user-box">
            <b-row>
              <!--div class="col-sm-8">
                <Profile :image="profileData.img" :name="profileData.name" :role="profileData.role"
                         :revenue="profileData.revenue" :orders="profileData.orders"/>
              </div-->

              <b-col sm="4">
                <div class="text-center mt-sm-0 mt-3 text-sm-end">
                  <b-button variant="light"> <i class="mdi mdi-account-edit me-1"></i> Edit Profile </b-button>
                </div>
              </b-col>
              <!-- end col-->
            </b-row>
            <!-- end row -->
          </div>
          <!-- end card-body/ profile-user-box-->
        </div>
        <!--end profile/ card -->
      </b-col>
      <!-- end col-->
    </b-row>
    <!-- end row -->
  </Layout>
</template>

<script lang="ts">
import Layout from '@/views/components/layouts/layout.vue'
import Breadcrumb from '@/views/components/breadcrumb.vue'
import { defineComponent, ref, type Ref } from 'vue'
import type { BreadcrumbItem } from 'bootstrap-vue-next'

export default defineComponent({
  components: { Layout, Breadcrumb },
  setup() {
    const title: Ref<string> = ref('Profile')

    const items: Ref<BreadcrumbItem[]> = ref([
      { text: 'Main', href: '/' },
      { text: 'Pages', href: '/' },
      { text: 'Profile', active: true },
    ])

    const profileData = ref({
      img: '/path/to/avatar',
      name: 'Michael Franklin',
      role: 'Authorised Brand Seller',
      revenue: '25,184',
      orders: 5482,
    })

    return {
      title,
      items,
      profileData,
    }
  },
})
</script>
